import { render } from "./forbidden.vue?vue&type=template&id=4160627a&lang=pug"
import script from "./forbidden.vue?vue&type=script&lang=js"
export * from "./forbidden.vue?vue&type=script&lang=js"

import "./forbidden.vue?vue&type=style&index=0&id=4160627a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__